// @tennis-matches/ui/tournament-setup/steps – KO-only Step (Clubmeisterschaft mode "ko")

import React from "react";
import { ClubSeedingFields } from "./ClubSeedingFields.jsx";

export function KoOnlyStep({
  t,
  value,
  onChange,
  entrantsCount,
  names,
  lkByPlayer,
}) {
  const v = value && typeof value === "object" ? value : {};
  const ko = v.ko && typeof v.ko === "object" ? v.ko : {};

  const bracketSize = Number(ko.bracketSize || 8);
  const seedingMode = ko.seedingMode || "random"; // "random" | "seeded"
  const thirdPlaceMatch = !!ko.thirdPlaceMatch;

  const setKo = (patch) =>
    onChange({ ...v, ko: { ...ko, ...patch, __touched: true } });

  const isPow2 = (n) => Number.isInteger(n) && n > 0 && (n & (n - 1)) === 0;
  const errors = [];
  if (!isPow2(bracketSize) || bracketSize < 4) {
    errors.push({ key: "club.groupsko.error.bracketSize" });
  }
  if (
    entrantsCount != null &&
    entrantsCount > 0 &&
    bracketSize !== entrantsCount
  ) {
    errors.push({
      key: "club.ko.error.bracketMustEqualEntrants",
      vars: { entrants: entrantsCount },
    });
  }

  return (
    <div className="wizardStep">
      <div className="wizardStep__section">
        <h3 className="wizardStep__title">{t("club.ko.title")}</h3>

        {errors.length > 0 ? (
          <div className="tm-wizard-error-box" role="alert" aria-live="polite">
            <p className="tm-wizard-error-box__title">
              {t("club.wizard.fixToContinue")}
            </p>
            <ul>
              {errors.map((e, idx) => (
                <li key={idx}>{t(e.key, e.vars)}</li>
              ))}
            </ul>
            <p className="tm-wizard-hint-box tm-wizard-hint-box--inline">
              {t("club.ko.info.entrants", { entrants: entrantsCount ?? 0 })}
            </p>
            {entrantsCount && isPow2(entrantsCount) && entrantsCount >= 4 ? (
              <button
                type="button"
                className="tm-wizard-v0__btn tm-wizard-v0__btn--primary"
                onClick={() => setKo({ bracketSize: entrantsCount })}
              >
                {t("club.ko.applySuggestion", { n: entrantsCount })}
              </button>
            ) : null}
          </div>
        ) : null}

        <p className="tm-wizard-hint-box">
          {t("club.ko.hint.noByes", { n: entrantsCount })}
        </p>

        <label className="wizardField">
          <span className="wizardField__label">{t("club.ko.bracketSize")}</span>
          <select
            className="wizardField__input"
            value={bracketSize}
            onChange={(e) => setKo({ bracketSize: Number(e.target.value) })}
          >
            {[4, 8, 16, 32].map((n) => (
              <option key={n} value={n}>
                {t(`club.ko.bracket.${n}`)}
              </option>
            ))}
          </select>
        </label>

        <ClubSeedingFields
          t={t}
          entrantsCount={entrantsCount}
          names={names}
          lkByPlayer={lkByPlayer}
          seedingMode={seedingMode}
          seedCount={ko.seedCount ?? 0}
          seedingTouched={!!ko.__seedingTouched}
          onSeedingChange={({
            seedingMode: mode,
            seedCount: count,
            seedingTouched,
          }) =>
            setKo({
              seedingMode: mode,
              seedCount: count,
              __seedingTouched: seedingTouched,
            })
          }
        />

        <label className="wizardField wizardField--checkbox">
          <input
            type="checkbox"
            checked={thirdPlaceMatch}
            onChange={(e) => setKo({ thirdPlaceMatch: e.target.checked })}
          />
          <span>{t("club.ko.thirdPlace")}</span>
        </label>

        {entrantsCount && isPow2(entrantsCount) && entrantsCount >= 4 ? (
          <button
            type="button"
            className="tm-wizard-v0__btn"
            onClick={() => setKo({ bracketSize: entrantsCount })}
          >
            {t("club.ko.applySuggestion", { n: entrantsCount })}
          </button>
        ) : null}
      </div>
    </div>
  );
}
